// extracted by mini-css-extract-plugin
module.exports = {"description":"NewsEvents_description__2JYLX","postscript":"NewsEvents_postscript__RFjF8"};